var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.src,"contain":"","height":_vm.height},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }